import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@apollo/client';
import { useCallback, useLayoutEffect, useMemo, useState } from 'react';
const INITIAL_FETCH_MORE_STATE = {
  fetchMoreError: null,
  fetchMoreLoading: false
};
export const PAGINATED_APP_GRID_CONFIG = {
  initialFetchCount: 24,
  fetchMoreCount: 12
};
export function usePaginatedAppGrid(_ref) {
  let {
    query,
    queryOptions,
    parseResponse
  } = _ref;
  // Note: Apollo Client's `useLazyQuery` and `useQuery` does not return errors for `fetchMore` calls.
  // Also, unless `notifyOnNetworkStatusChange` is set, it doesn't return loading state either for `fetchMore`.
  // We manage `fetchMoreState` state explicitly to handle these cases.
  // https://github.com/apollographql/react-apollo/issues/2759
  const [fetchMoreState, setFetchMoreState] = useState(INITIAL_FETCH_MORE_STATE);
  const {
    data,
    error,
    loading,
    fetchMore
  } = useQuery(query, queryOptions);
  const {
    appList,
    hasNextPage,
    totalCount
  } = parseResponse(data);
  const showLoadMoreButton = !error && hasNextPage;
  useLayoutEffect(() => {
    if (loading && fetchMoreState.fetchMoreError) {
      setFetchMoreState(INITIAL_FETCH_MORE_STATE);
    }
  }, [loading, fetchMoreState.fetchMoreError]);
  const fetchMoreApps = useCallback(async _ref2 => {
    let {
      first = PAGINATED_APP_GRID_CONFIG.fetchMoreCount,
      variables = {}
    } = _ref2;
    if (!fetchMore || !hasNextPage) return; // no-op

    setFetchMoreState({
      fetchMoreError: null,
      fetchMoreLoading: true
    });
    try {
      await fetchMore({
        variables: _objectSpread({
          after: appList.length,
          // how many elements do you want to skip
          first
        }, variables)
      });
      setFetchMoreState(INITIAL_FETCH_MORE_STATE);
    } catch (err) {
      setFetchMoreState({
        fetchMoreError: err,
        fetchMoreLoading: false
      });
    }
  }, [fetchMore, appList.length, hasNextPage]);
  return useMemo(() => ({
    appList,
    totalCount,
    isLoading: loading,
    isLoadingMore: fetchMoreState.fetchMoreLoading,
    showLoadMoreButton,
    fetchMoreApps,
    rawData: data,
    initialFetchError: error,
    fetchMoreError: fetchMoreState.fetchMoreError
  }), [appList, totalCount, loading, fetchMoreState.fetchMoreLoading, showLoadMoreButton, fetchMoreApps, data, error, fetchMoreState.fetchMoreError]);
}